export default __webpack_public_path__ + "static/media/traveller-3.e84577ed.jpg";